export const NO_NONE_NOPES = [
  'nope',
  'no',
  'no.',
  'none',
  'none.',
  'n/a',
  'na',
  'not applicable',
  ',',
  '.',
  '-',
  '0'
]

export const NO_NONE_NOPE_FIELD_DATA = {
  dietaryRestrictionsOther: 'dietary restrictions',
  medications: 'medications',
  medicalConditions: 'medical conditions',
  parentNotes: 'additional comments',
  foodAllergyNotes: 'additional food allergy notes',
  nonFoodAllergyNotes: 'additional non-food allergy notes'
}
